var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 7,
    viewBox: "0 0 25 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59961 3.37891L5.93945 4.55664V6.19727L0.894531 4.05859V2.67578L5.93945 0.537109V2.17773L2.59961 3.37891ZM8.70508 3.37891L12.0449 4.55664V6.19727L7 4.05859V2.67578L12.0449 0.537109V2.17773L8.70508 3.37891ZM14.8105 3.37891L18.1504 4.55664V6.19727L13.1055 4.05859V2.67578L18.1504 0.537109V2.17773L14.8105 3.37891ZM20.916 3.37891L24.2559 4.55664V6.19727L19.2109 4.05859V2.67578L24.2559 0.537109V2.17773L20.916 3.37891Z",
    fill: "#FA7D36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.2d4daa084bb2f28237e7fe545c3d605b.svg";
export { ForwardRef as ReactComponent };